import { Box, Button, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SegmentTag } from 'types/global';
interface Props {
  setShowRegisterModal: (a: boolean) => void;
  segment: SegmentTag;
  position: 'list' | 'details';
}
export const SignInBanner: React.FC<Props> = props => {
  return (
    <Box
      sx={theme => ({
        backgroundColor: theme.palette.primary.main,
        backgroundImage:
          props.segment === SegmentTag.PERSONALCARE
            ? `url(
             'https://static.covalo.com/rx/abstractBubbles.webp')`
            : 'default',
        backgroundSize: 'cover',
        backgroundPosition: props.position === 'details' ? 'bottom' : 'center',
        display: 'flex',
        alignItems: props.position === 'details' ? 'end' : 'center',
        flexDirection:
          props.position === 'details'
            ? 'column'
            : {
                xs: 'column',
                xl: 'row'
              },
        justifyContent: 'space-between',
        padding: '8px 16px'
      })}
    >
      <div>
        <Typography
          variant="body1"
          sx={{
            color: 'white'
          }}
        >
          {props.position === 'list'
            ? 'Discover and connect with thousands of suppliers.'
            : //TODO: Check with marketing about number of attributes
              'With a free account you can view more attributes and request documents!'}
        </Typography>
        {props.position === 'list' && (
          <Typography
            variant="caption"
            sx={{
              color: 'white'
            }}
          >
            Sign up in few minutes and get access to thousands of suppliers and
            more product information.
          </Typography>
        )}
      </div>
      <div>
        <Button
          variant="text"
          sx={{
            color: 'white'
          }}
          onClick={() => props.setShowRegisterModal(true)}
        >
          Discover more
        </Button>
        <Button
          variant="outlined"
          sx={{ background: 'white' }}
          component={Link}
          to="/register"
        >
          <Trans i18nKey="auth.signup" />
        </Button>
      </div>
    </Box>
  );
};
